<template>
  <section class="book-simple-box">
    <div class="container">
      <div class="search-empty">
        <img
          class="search-empty__img"
          src="@/assets.app/images/no-search.svg"
        />
        <h3 class="search-empty__title">No results found for "{{ term }}"</h3>
        <p>
          Try another search, or send us an email with books and podcasts
          suggestions that you're interested in!
        </p>
        <router-link
          :to="{ name: 'help' }"
          class="btns btns--font-medium btns--white search-empty__btn"
        >
          Request books or podcasts from us</router-link
        >
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  term: string
}>()
</script>
